import { createChart, ColorType, CandlestickSeries } from 'lightweight-charts';
import React, { useEffect, useRef } from 'react';

const LightweightChartV2 = (props) => {
    const {
        data,
        colors: {
            backgroundColor = 'white',
            lineColor = '#2962FF',
            textColor = 'black',
            upColor = '#26a69a',
            downColor = '#ef5350',
            wickUpColor = '#26a69a',
            wickDownColor = '#ef5350',
        } = {},
    } = props;

    const chartContainerRef = useRef();
    const chartRef = useRef();
    const seriesRef = useRef();

    useEffect(() => {
        console.log("LightweightChartV2: Initializing chart");
        // Create chart instance
        const chart = createChart(chartContainerRef.current, {
            layout: {
                background: { type: ColorType.Solid, color: backgroundColor },
                textColor,
            },
            width: chartContainerRef.current.clientWidth,
            height: chartContainerRef.current.clientHeight || 500, // Fallback to 500 if container has 0 height
            grid: {
                vertLines: { color: '#e1e1e1' },
                horzLines: { color: '#e1e1e1' },
            },
            timeScale: {
                timeVisible: true,
                secondsVisible: false,
            },
        });

        // Add Candlestick Series
        const newSeries = chart.addSeries(CandlestickSeries, {
            upColor,
            downColor,
            borderVisible: false,
            wickUpColor,
            wickDownColor,
        });

        // Store references
        chartRef.current = chart;
        seriesRef.current = newSeries;

        // Set initial data if any
        if (data && data.length > 0) {
            console.log("LightweightChartV2: Setting initial data", data.length);
            newSeries.setData(data);
            chart.timeScale().fitContent();
        }

        // ResizeObserver for responsive sizing
        const resizeObserver = new ResizeObserver(entries => {
            if (entries.length === 0 || !entries[0].target) return;
            const newRect = entries[0].contentRect;
            if (newRect.width > 0 && newRect.height > 0) {
                chart.applyOptions({ width: newRect.width, height: newRect.height });
            }
        });

        resizeObserver.observe(chartContainerRef.current);

        return () => {
            resizeObserver.disconnect();
            chart.remove();
            chartRef.current = null;
            seriesRef.current = null;
        };
    }, [backgroundColor, textColor, upColor, downColor, wickUpColor, wickDownColor]);

    // Separate effect for data updates to avoid re-creating chart
    useEffect(() => {
        if (seriesRef.current && data && data.length > 0) {
            const first = data[0];
            const last = data[data.length - 1];
            console.log(`[LightweightChartV2] Updating chart. Count: ${data.length}`);
            console.log(`[LightweightChartV2] Range: ${first.time} (${new Date(first.time * 1000).toISOString()}) to ${last.time} (${new Date(last.time * 1000).toISOString()})`);

            try {
                seriesRef.current.setData(data);
                chartRef.current.timeScale().fitContent();
            } catch (e) {
                console.error("[LightweightChartV2] Error updating chart data:", e);
            }
        } else {
            console.log(`[LightweightChartV2] Data update skipped. seriesRef: ${!!seriesRef.current}, data len: ${data?.length}`);
        }
    }, [data]);

    return (
        <div ref={chartContainerRef} className="w-full h-full relative" />
    );
};

export default LightweightChartV2;
